import { useEffect, useState } from "react";
import { ExerciseDONE } from "@/types";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import { SpinnerLoader } from "@/components/ui/Loader";
import { useNavigate, useParams } from "react-router-dom";
import useCorrection from "@/utils/hooks/useCorrection.ts";
import ExerciseLayout from "@/layouts/ExerciseLayout.tsx";
import CorrectionAnswerSheet from "@/components/v3/correction/CorrectionAnswerSheet.tsx";
import DesktopCorrectionWithAI from "@/components/v3/correction/DesktopCorrectionWithAI.tsx";

function WritingExerciseCorrection() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getCorrection } = useCorrection();

  const [exercise, setExercise] = useState<ExerciseDONE | null>(null);
  const [showTutorCorrectedEssay, setShowTutorCorrectedEssay] = useState(false);

  useEffect(() => {
    if (id) {
      const result = getCorrection(id);
      if (result) setExercise(result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  //convert string null to null

  return (
    <ExerciseLayout
      isCorrection
      type={ExerciseType.WRITING}
      title={(exercise as { test_name?: string })?.test_name}
      onClose={() => navigate(-1)}
      onViewEssayByTutor={() => setShowTutorCorrectedEssay((r) => !r)}
    >
      {!exercise ? (
        <div className="flex items-center justify-center w-full h-full">
          <SpinnerLoader className={"!h-12 !w-12 border-t-light"} />
        </div>
      ) : (
        <CorrectionAnswerSheet
          exercise={exercise}
          renderSlots={() =>
            showTutorCorrectedEssay ? (
              <iframe
                loading="lazy"
                width={"100%"}
                height={"100%"}
                className="xl:flex-[1_1_40%]"
                title={exercise.test_name}
                src={`https://docs.google.com/file/d/${exercise?.user_submit?.file_id as string
                  }/preview?usp=drivesdk`}
              />
            ) : (
              <DesktopCorrectionWithAI
                title={exercise.test_name}
                exerciseRawTextAnswer={exercise.raw_text_answer}
                essaycheckerInfo={
                  typeof exercise.essaychecker_result === "string" && exercise.essaychecker_result.toLowerCase() !== "null" ? exercise.essaychecker_result : "[]"
                }
                driveKey={exercise?.user_submit?.file_id as string} />
            )
          }
        />
      )}
    </ExerciseLayout>
  );
}

export default WritingExerciseCorrection;
